// Lib
import { Action } from 'redux';

// Constants
import * as ACTIONS from './actionTypes';

export interface ActionDealerCacheSyncRequest extends Action {
    listingId
}

export const postDealerCacheSync = (listingId: string): ActionDealerCacheSyncRequest => ({
    type: ACTIONS.POST_DEALER_CACHE_SYNC_API_REQUEST,
    listingId
});

export interface ActionDealerCacheSyncRequestSuccess extends Action {
}

export const postDealerCacheSyncSuccess = (): ActionDealerCacheSyncRequestSuccess => ({
    type: ACTIONS.POST_DEALER_CACHE_SYNC_API_SUCCESS,
});

export const postDealerCacheSyncError = (error): Action & { error: any } => ({
    type: ACTIONS.POST_DEALER_CACHE_SYNC_API_ERROR,
    error
});

export const postListingCacheSync = (listingId: string): ActionDealerCacheSyncRequest => ({
    type: ACTIONS.POST_LISTING_DEPARTMENT_CACHE_API_REQUEST,
    listingId
});

export const postListingCacheSyncSuccess = (): ActionDealerCacheSyncRequestSuccess => ({
    type: ACTIONS.POST_LISTING_DEPARTMENT_CACHE_API_SUCCESS,
});

export const postListingCacheSyncError = (error): Action & { error: any } => ({
    type: ACTIONS.POST_LISTING_DEPARTMENT_CACHE_API_ERROR,
    error
});